import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c52cdad")

_pushScopeId("data-v-6c52cdad")
const _hoisted_1 = {
  key: 0,
  class: "dashboard-main"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12-sm col-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h4", { class: "ls-slate" }, "Loading...", -1)
const _hoisted_6 = {
  key: 1,
  class: "dashboard-main"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12-sm col-12" }, [
      /*#__PURE__*/_createVNode("h4", { class: "ls-slate" }, "Error loading data")
    ])
  ])
], -1)
const _hoisted_8 = {
  key: 2,
  class: "dashboard-main"
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 topbar-main" }
const _hoisted_12 = { class: "ls-slate welcome-line" }
const _hoisted_13 = { class: "topbar-buttons" }
const _hoisted_14 = {
  key: 0,
  class: "comingup-committee-main"
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12 mt-4 mb-4 committee-header-status" }
const _hoisted_18 = { class: "committee-info" }
const _hoisted_19 = { class: "white" }
const _hoisted_20 = /*#__PURE__*/_createVNode("h3", { class: "white" }, "Expression of interest", -1)
const _hoisted_21 = { class: "committee-period" }
const _hoisted_22 = { class: "committee-status-main" }
const _hoisted_23 = { class: "committee-status" }
const _hoisted_24 = {
  key: 0,
  class: "white"
}
const _hoisted_25 = {
  key: 1,
  class: "white"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("small", null, "Application status", -1)
const _hoisted_27 = {
  key: 0,
  class: "committee-todo"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, "Review Application", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "fal fa-angle-right" })
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "Apply Now", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "fal fa-angle-right" })
], -1)
const _hoisted_32 = {
  key: 1,
  class: "current-committee-main mt-2"
}
const _hoisted_33 = { class: "container" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-12 mt-4 mb-4 current-committee-header-status" }
const _hoisted_36 = { class: "white" }
const _hoisted_37 = { class: "committee-period" }
const _hoisted_38 = {
  key: 0,
  class: "col-12 committee-main"
}
const _hoisted_39 = { class: "committee" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "border-top" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("button", { class: "btn sml" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-chevron-right" })
], -1)
const _hoisted_42 = { class: "agenda-info ml-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", null, "AGENDA:", -1)
const _hoisted_44 = { class: "agenda-datetime" }
const _hoisted_45 = {
  key: 1,
  class: "no-agenda"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fal fa-info-circle fa-lg" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" No scheduled meeting ")
const _hoisted_48 = {
  key: 2,
  class: "file-list"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "fal fa-file-pdf mr-3" }, null, -1)
const _hoisted_50 = {
  key: 2,
  class: "row ma-2"
}
const _hoisted_51 = { class: "details-panel-main" }
const _hoisted_52 = { class: "container" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-12 details-panel" }
const _hoisted_55 = {
  key: 0,
  class: "personal-details"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("h3", null, "Personal Details", -1)
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Name")
], -1)
const _hoisted_59 = { class: "col-8" }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "LawID number")
], -1)
const _hoisted_62 = { class: "col-8" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "PC holder")
], -1)
const _hoisted_65 = { class: "col-8" }
const _hoisted_66 = {
  key: 0,
  class: "row"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Year of admission")
], -1)
const _hoisted_68 = { class: "col-8" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Law Society Member")
], -1)
const _hoisted_71 = { class: "col-8" }
const _hoisted_72 = {
  key: 1,
  class: "employment-details"
}
const _hoisted_73 = /*#__PURE__*/_createTextVNode("Employment Details")
const _hoisted_74 = {
  key: 0,
  class: "row"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Law practice name")
], -1)
const _hoisted_76 = { class: "col-8" }
const _hoisted_77 = {
  key: 1,
  class: "row"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Employment status")
], -1)
const _hoisted_79 = { class: "col-8" }
const _hoisted_80 = {
  key: 2,
  class: "row"
}
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Firm / Organisation name")
], -1)
const _hoisted_82 = { class: "col-8" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_86 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_87 = {
  key: 2,
  class: "contact-details"
}
const _hoisted_88 = /*#__PURE__*/_createTextVNode("Committee Contact Details")
const _hoisted_89 = { class: "row" }
const _hoisted_90 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee postal address")
], -1)
const _hoisted_91 = { class: "col-8" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_95 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_96 = { class: "row" }
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee phone number")
], -1)
const _hoisted_98 = { class: "col-8" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_102 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_103 = { class: "row" }
const _hoisted_104 = /*#__PURE__*/_createVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createVNode("h4", null, "Committee email address")
], -1)
const _hoisted_105 = { class: "col-8" }
const _hoisted_106 = { key: 1 }
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Missing information, please ")
const _hoisted_108 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_109 = /*#__PURE__*/_createVNode("h4", null, "Notice", -1)
const _hoisted_110 = { class: "disclosure-box" }
const _hoisted_111 = { style: {"white-space":"pre-line"} }
const _hoisted_112 = { class: "ls-slate" }
const _hoisted_113 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_114 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_AlertBox = _resolveComponent("AlertBox")
  const _component_HelpScreen = _resolveComponent("HelpScreen")
  const _component_DetailsEdit = _resolveComponent("DetailsEdit")

  return (_ctx.isLoadingData)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_LoadingSpinner)
            ])
          ])
        ])
      ]))
    : (_ctx.errorLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _hoisted_7
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("h4", _hoisted_12, "Welcome " + _toDisplayString(_ctx.userName), 1),
                _createVNode("div", _hoisted_13, [
                  _createVNode("button", {
                    class: "btn btn-tertiary sml mr-2",
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.contactUs()))
                  }, "Contact Us")
                ])
              ])
            ])
          ]),
          (!_ctx.isEoiBeingAssessed && (_ctx.isInEoiPeriod && !_ctx.hasAssessedEoiForm) || (_ctx.isInEoiPeriodManual && !_ctx.hasAssessedEoiForm))
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("h2", _hoisted_19, _toDisplayString(_ctx.comingCommitteeName), 1),
                        _hoisted_20,
                        _createVNode("h3", _hoisted_21, _toDisplayString(_ctx.comingCommitteeYearStart) + " - " + _toDisplayString(_ctx.comingCommitteeYearEnd), 1)
                      ]),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("div", _hoisted_23, [
                          (_ctx.eoiForm !== null)
                            ? (_openBlock(), _createBlock("h3", _hoisted_24, "Applied on " + _toDisplayString(_ctx.eoiSubmittedOn), 1))
                            : (_openBlock(), _createBlock("h3", _hoisted_25, " Not applied")),
                          _hoisted_26
                        ]),
                        (!_ctx.isEoiBeingAssessed)
                          ? (_openBlock(), _createBlock("div", _hoisted_27, [
                              (_ctx.eoiForm !== null)
                                ? (_openBlock(), _createBlock("button", {
                                    key: 0,
                                    class: "btn btn-primary",
                                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.eoiReview()))
                                  }, [
                                    _hoisted_28,
                                    _hoisted_29
                                  ]))
                                : (_openBlock(), _createBlock("button", {
                                    key: 1,
                                    class: "btn btn-primary",
                                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.eoiApply()))
                                  }, [
                                    _hoisted_30,
                                    _hoisted_31
                                  ]))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.myCommittees?.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                _createVNode("div", {
                  class: ['backgroundbox', _ctx.myCommittees.length == 0 ? 'no-committee' : '']
                }, null, 2),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode("div", _hoisted_35, [
                      _createVNode("h2", _hoisted_36, _toDisplayString(_ctx.currentCommitteeName), 1),
                      _createVNode("h3", _hoisted_37, _toDisplayString(_ctx.currentCommitteeYearStart) + " - " + _toDisplayString(_ctx.currentCommitteeYearEnd), 1)
                    ]),
                    (_ctx.myCommittees)
                      ? (_openBlock(), _createBlock("div", _hoisted_38, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.myCommittees, (c, index) => {
                            return (_openBlock(), _createBlock("div", _hoisted_39, [
                              _hoisted_40,
                              _createVNode("h3", {
                                class: "committee-name",
                                title: c.name
                              }, _toDisplayString(c.name), 9, ["title"]),
                              (c.meeting)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    class: "agenda",
                                    onClick: $event => (_ctx.agendaClicked(c.meeting, c.id))
                                  }, [
                                    _hoisted_41,
                                    _createVNode("div", _hoisted_42, [
                                      _createVNode("div", {
                                        class: "agenda-name",
                                        title: c.name
                                      }, [
                                        _hoisted_43,
                                        _createTextVNode(" " + _toDisplayString(c.name), 1)
                                      ], 8, ["title"]),
                                      _createVNode("small", _hoisted_44, _toDisplayString(_ctx.getMeetingDateTime(c.meeting['meetingDateTime'])) + " " + _toDisplayString(_ctx.getMeetingType(c.meeting)), 1)
                                    ])
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (!c.meeting)
                                ? (_openBlock(), _createBlock("div", _hoisted_45, [
                                    _hoisted_46,
                                    _hoisted_47
                                  ]))
                                : _createCommentVNode("", true),
                              (c.files)
                                ? (_openBlock(), _createBlock("div", _hoisted_48, [
                                    _createVNode("ul", null, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileListSort(c.files), (f, index) => {
                                        return (_openBlock(), _createBlock("li", {
                                          class: "file-name",
                                          title: f.name,
                                          onClick: $event => (_ctx.generalFileClicked(f.id, c.id))
                                        }, [
                                          _hoisted_49,
                                          _createVNode("span", null, _toDisplayString(f.name), 1)
                                        ], 8, ["title", "onClick"]))
                                      }), 256))
                                    ]),
                                    (c.files.length > 3)
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 0,
                                          class: "btn btn-tertiary sml",
                                          onClick: $event => (_ctx.generalFileClicked(-1, c.id))
                                        }, "Show all files", 8, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_50)),
          _withDirectives(_createVNode("div", _hoisted_51, [
            _createVNode("div", _hoisted_52, [
              _createVNode("div", _hoisted_53, [
                _createVNode("div", _hoisted_54, [
                  (_ctx.personalDetail)
                    ? (_openBlock(), _createBlock("div", _hoisted_55, [
                        _hoisted_56,
                        _createVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createVNode("div", _hoisted_59, [
                            _createVNode("p", null, _toDisplayString(_ctx.personalDetail.displayName), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createVNode("div", _hoisted_62, [
                            _createVNode("p", null, _toDisplayString(_ctx.personalDetail.lawId), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createVNode("div", _hoisted_65, [
                            _createVNode("p", null, _toDisplayString(_ctx.personalDetail?.isPcHolder ? 'Yes' : 'No'), 1)
                          ])
                        ]),
                        (_ctx.isPcHolder)
                          ? (_openBlock(), _createBlock("div", _hoisted_66, [
                              _hoisted_67,
                              _createVNode("div", _hoisted_68, [
                                _createVNode("p", null, _toDisplayString(_ctx.personalDetail.admissionYear), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createVNode("div", _hoisted_71, [
                            _createVNode("p", null, _toDisplayString(_ctx.personalDetail.memberDescription), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.employmentDetail)
                    ? (_openBlock(), _createBlock("div", _hoisted_72, [
                        _createVNode("h3", null, [
                          _hoisted_73,
                          (!_ctx.isPcHolder)
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                class: "btn btn-tertiary sml ml-4",
                                onClick: _cache[4] || (_cache[4] = $event => (_ctx.showEditModal(2)))
                              }, "Edit"))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.isPcHolder)
                          ? (_openBlock(), _createBlock("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode("div", _hoisted_76, [
                                _createVNode("p", null, _toDisplayString(_ctx.employmentDetail.firmName), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isPcHolder)
                          ? (_openBlock(), _createBlock("div", _hoisted_77, [
                              _hoisted_78,
                              _createVNode("div", _hoisted_79, [
                                _createVNode("p", null, _toDisplayString(_ctx.personalDetail.solicitorTypeDescription), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (!_ctx.isPcHolder)
                          ? (_openBlock(), _createBlock("div", _hoisted_80, [
                              _hoisted_81,
                              _createVNode("div", _hoisted_82, [
                                (_ctx.employmentDetail.firmName)
                                  ? (_openBlock(), _createBlock("p", _hoisted_83, _toDisplayString(_ctx.employmentDetail.firmName), 1))
                                  : (_openBlock(), _createBlock("p", _hoisted_84, [
                                      _hoisted_85,
                                      _createVNode("span", {
                                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.showEditModal(3))),
                                        class: "link"
                                      }, "edit"),
                                      _hoisted_86
                                    ]))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.committeeContactDetail)
                    ? (_openBlock(), _createBlock("div", _hoisted_87, [
                        _createVNode("h3", null, [
                          _hoisted_88,
                          _createVNode("button", {
                            class: "btn btn-tertiary sml ml-4",
                            onClick: _cache[6] || (_cache[6] = $event => (_ctx.showEditModal(3)))
                          }, "Edit")
                        ]),
                        _createVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _createVNode("div", _hoisted_91, [
                            (_ctx.committeeContactDetail.address)
                              ? (_openBlock(), _createBlock("p", _hoisted_92, [
                                  _createVNode("pre", null, _toDisplayString(_ctx.getAddressEncoded()), 1)
                                ]))
                              : (_openBlock(), _createBlock("p", _hoisted_93, [
                                  _hoisted_94,
                                  _createVNode("span", {
                                    onClick: _cache[7] || (_cache[7] = $event => (_ctx.showEditModal(3))),
                                    class: "link"
                                  }, "edit"),
                                  _hoisted_95
                                ]))
                          ])
                        ]),
                        _createVNode("div", _hoisted_96, [
                          _hoisted_97,
                          _createVNode("div", _hoisted_98, [
                            (_ctx.committeeContactDetail.phone)
                              ? (_openBlock(), _createBlock("p", _hoisted_99, _toDisplayString(_ctx.getPhoneNumber()), 1))
                              : (_openBlock(), _createBlock("p", _hoisted_100, [
                                  _hoisted_101,
                                  _createVNode("span", {
                                    class: "link",
                                    onClick: _cache[8] || (_cache[8] = $event => (_ctx.showEditModal(3)))
                                  }, "edit"),
                                  _hoisted_102
                                ]))
                          ])
                        ]),
                        _createVNode("div", _hoisted_103, [
                          _hoisted_104,
                          _createVNode("div", _hoisted_105, [
                            (_ctx.committeeContactDetail.email)
                              ? (_openBlock(), _createBlock("p", {
                                  key: 0,
                                  title: _ctx.committeeContactDetail.email,
                                  class: "email"
                                }, _toDisplayString(_ctx.committeeContactDetail.email), 9, ["title"]))
                              : (_openBlock(), _createBlock("p", _hoisted_106, [
                                  _hoisted_107,
                                  _createVNode("span", {
                                    class: "link",
                                    onClick: _cache[9] || (_cache[9] = $event => (_ctx.showEditModal(3)))
                                  }, "edit"),
                                  _hoisted_108
                                ]))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 512), [
            [_vShow, !_ctx.isNewMember]
          ]),
          (_ctx.showCancelAlertBox)
            ? (_openBlock(), _createBlock(_component_AlertBox, {
                key: 3,
                onClose: _cache[12] || (_cache[12] = $event => (_ctx.showCancelAlertBox = false))
              }, {
                header: _withId(() => [
                  _hoisted_109
                ]),
                body: _withId(() => [
                  _createVNode("div", _hoisted_110, [
                    _createVNode("small", _hoisted_111, _toDisplayString(_ctx.disclosure), 1)
                  ])
                ]),
                footer: _withId(() => [
                  _createVNode("button", {
                    class: "btn btn-secondary sml",
                    onClick: _cache[10] || (_cache[10] = $event => (_ctx.agendaViewing()))
                  }, "Yes, I agree."),
                  _createVNode("button", {
                    class: "btn btn-tertiary sml",
                    onClick: _cache[11] || (_cache[11] = $event => (_ctx.showCancelAlertBox = false))
                  }, "No, I do not agree.")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showHelpScreen)
            ? (_openBlock(), _createBlock(_component_HelpScreen, {
                key: 4,
                onClose: _cache[13] || (_cache[13] = $event => (_ctx.showHelpScreen = false))
              }, {
                header: _withId(() => [
                  _createVNode("h3", _hoisted_112, _toDisplayString(_ctx.pageHeader), 1)
                ]),
                body: _withId(() => [
                  _createVNode("p", null, _toDisplayString(_ctx.pageDescription), 1),
                  _hoisted_113,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageSection, (s, index) => {
                    return (_openBlock(), _createBlock("div", null, [
                      _createVNode("h4", null, _toDisplayString(s.sectionHeading), 1),
                      _createVNode("p", null, _toDisplayString(s.sectionContent), 1),
                      _hoisted_114
                    ]))
                  }), 256))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showModalDetailsEdit)
            ? (_openBlock(), _createBlock(_component_DetailsEdit, {
                key: 5,
                pDetails: _ctx.personalDetail,
                "onUpdate:pDetails": _cache[14] || (_cache[14] = $event => (_ctx.personalDetail = $event)),
                eDetails: _ctx.employmentDetail,
                "onUpdate:eDetails": _cache[15] || (_cache[15] = $event => (_ctx.employmentDetail = $event)),
                cDetails: _ctx.committeeContactDetail,
                "onUpdate:cDetails": _cache[16] || (_cache[16] = $event => (_ctx.committeeContactDetail = $event)),
                myCommittees: _ctx.myCommittees,
                "onUpdate:myCommittees": _cache[17] || (_cache[17] = $event => (_ctx.myCommittees = $event)),
                onClose: _cache[18] || (_cache[18] = $event => (_ctx.showModalDetailsEdit = false)),
                editType: _ctx.editType
              }, null, 8, ["pDetails", "eDetails", "cDetails", "myCommittees", "editType"]))
            : _createCommentVNode("", true)
        ]))
})